function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import { AwsRum } from "aws-rum-web";
var awsRum = null;
export function initializeAWSRum(rumUIParams) {
    try {
        var APPLICATION_ID = rumUIParams.APPLICATION_ID, APPLICATION_VERSION = rumUIParams.APPLICATION_VERSION, APPLICATION_REGION = rumUIParams.APPLICATION_REGION, config = rumUIParams.config;
        awsRum = new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config);
    } catch (error) {
    // Rum initialisation is failed
    }
    return awsRum;
}
export function getAWSRumInstance(rumUIParams) {
    return _getAWSRumInstance.apply(this, arguments);
}
function _getAWSRumInstance() {
    _getAWSRumInstance = _asyncToGenerator(function(rumUIParams) {
        return __generator(this, function(_state) {
            if (awsRum) {
                return [
                    2,
                    awsRum
                ];
            }
            if (rumUIParams) {
                awsRum = initializeAWSRum(rumUIParams);
            }
            return [
                2,
                awsRum
            ];
        });
    });
    return _getAWSRumInstance.apply(this, arguments);
}
export function recordErrorInCloudWatchRUM(message) {
    getAWSRumInstance().then(function(awsRum) {
        if (awsRum) {
            var ref;
            (ref = awsRum.recordError) === null || ref === void 0 ? void 0 : ref.call(awsRum, message);
        }
    });
}
export function recordCustomEventInCloudWatchRUM(eventName, eventProperties) {
    getAWSRumInstance().then(function(awsRum) {
        if (awsRum) {
            var ref;
            awsRum === null || awsRum === void 0 ? void 0 : (ref = awsRum.recordEvent) === null || ref === void 0 ? void 0 : ref.call(awsRum, eventName, _objectSpread({
                view_properties: {
                    page: window.location.pathname
                }
            }, eventProperties));
        }
    });
}
export function setCustomSessionProperties(customSessionProperties, rumUIParams) {
    getAWSRumInstance(rumUIParams).then(function(awsRum) {
        if (awsRum) {
            var ref;
            (ref = awsRum.addSessionAttributes) === null || ref === void 0 ? void 0 : ref.call(awsRum, customSessionProperties);
        }
    });
}
export default getAWSRumInstance;

//# sourceMappingURL=index.js.map